import React, { useContext } from "react";
import { ScratchpadContext } from "contexts/ScratchpadProvider";
import NavIcon from "components/navigation/NavIcon";
import NavigationButton from "components/navigation/NavigationButton";
const ScratchpadToggle = () => {
  const { toggleScratchpadVisibility } = useContext(ScratchpadContext);
  return /* @__PURE__ */ React.createElement("li", { role: "presentation" }, /* @__PURE__ */ React.createElement(NavigationButton, { "aria-label": "Scratchpad", id: "scratchpad-toggle", onClick: toggleScratchpadVisibility }, /* @__PURE__ */ React.createElement(NavIcon, { type: "scratchpad", title: "Scratchpad" })));
};
export default ScratchpadToggle;
